export default __webpack_public_path__ + "static/media/fm.6367edfe.svg";